<div fxLayout="column">
  <h2 mat-dialog-title>INFORMATION</h2>
  <mat-dialog-content class="margin-bot" fxLayoutAlign="center center">
    Impossible de créer le dossier en raison d'informations manquantes ou erronées.
  </mat-dialog-content>
  <mat-dialog-content class="margin-bot">
    
    <div *ngIf="data">
      <div *ngFor="let key of dataKeys" style="margin-bottom: 8px;">
        <strong>{{ data[key] }}</strong>
      </div>
    </div>
    <div *ngIf="!data">
      Aucune donnée disponible.
    </div>
  </mat-dialog-content>
  <mat-dialog-actions fxLayout="row" fxLayoutAlign="end center">
    <button mat-flat-button mat-dialog-close class="button-flat black">Fermer</button>
  </mat-dialog-actions>
</div>
